import React, { useState, useEffect } from 'react';
import Button from '../../components/ui/Button';
import PipelineView from './PipelineView';
import ClientsTable from './ClientsTable';
import ClientModal from './ClientModal';
import { useAuth } from '../../contexts/AuthContext';
import {  createClient } from '../../services/clientService';
import { useSearchParams } from 'react-router-dom';
import { useUserProfile } from '../../contexts/UserContext';
import { useSubscriptionGuard } from '../../services/useSubscriptionGuard';
import { subscribeClientsByRole } from '../../services/clientService';
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../../services/firebase';

export default function CRMPage() {
  const { user } = useAuth();
 const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'clients';
  const [modalOpen, setModalOpen] = useState(false);
  const [clients, setClients] = useState([]);
  const [editCliente, setEditCliente] = useState(null);
  
  const setTab = (t) => setSearchParams({ tab: t });
  const { profile } = useUserProfile();
  const { canPerform } = useSubscriptionGuard();
  

  useEffect(() => {
  if (!profile) return;
  const unsub = subscribeClientsByRole(profile, setClients);
  return unsub;
}, [profile]);

const handleCreate = async (dados) => {
  // Verificar limite de clientes
  const check = canPerform('clientes', clients.length);
  if (!check.allowed) {
    alert(check.reason);
    return;
  }
  await createClient(user.uid, dados, profile);
};

//
const migrarDados = async () => {
  const uid = 'rFyXc4YoljNkeVZ9LuiuWKgcXpd2';
  const cols = ['clients', 'simulations', 'pdfs'];
  for (const col of cols) {
    const snap = await getDocs(collection(db, col));
    for (const d of snap.docs) {
      if (!d.data().masterId) {
        await updateDoc(doc(db, col, d.id), {
          userId: uid,
          masterId: uid,
          gestorId: uid,
        });
      }
    }
  }
  alert('Migração concluída! Recarregue a página.');
};




  // Stats calculados dos dados reais
  const totalClients = clients.length;
  const activeClients = clients.filter((c) => c.stage !== 'perdido').length;

  const stats = [
    { valor: totalClients.toString(), label: 'Total Clientes', cor: 'var(--blue)', pct: 100 },
    { valor: activeClients.toString(), label: 'Ativos', cor: 'var(--accent)', pct: totalClients ? (activeClients / totalClients) * 100 : 0 },
  ];

  return (
    <>
      {/* Topbar */}
      <div className="crm-topbar" style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24,
        flexWrap: 'wrap', gap: 12,
      }}>
        <div style={{
          display: 'flex', gap: 4, background: 'var(--white)', border: '1px solid var(--border)',
          borderRadius: 'var(--radius-sm)', padding: 4, width: 'fit-content', flexShrink: 0,
        }}>
          {[
            { key: 'pipeline', icon: '🏗️', label: 'Pipeline' },
            { key: 'clients', icon: '👥', label: 'Clientes' },
          ].map((t) => (
            <button key={t.key} onClick={() => setTab(t.key)} style={{
              padding: '8px 18px', borderRadius: 'var(--radius-xs)', fontSize: '0.82rem',
              fontWeight: 600, cursor: 'pointer', border: 'none', fontFamily: 'var(--font)',
              background: tab === t.key ? 'var(--accent)' : 'transparent',
              color: tab === t.key ? 'var(--primary)' : 'var(--text-muted)',
              transition: 'all 0.15s', whiteSpace: 'nowrap',
            }}>
              {t.icon} {t.label}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Button variant="ghost" onClick={migrarDados}>🔧 Migrar Dados</Button>
          <Button variant="ghost">📥 Importar</Button>
          <Button variant="accent" onClick={() => setModalOpen(true)}>+ Novo Cliente</Button>
        </div>
      </div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${stats.length}, 1fr)`, gap: 14, marginBottom: 24 }}>
        {stats.map((stat) => (
          <div key={stat.label} style={{
            background: 'var(--white)', border: '1px solid var(--border)',
            borderRadius: 'var(--radius)', padding: '16px 18px',
          }}>
            <div style={{ fontSize: '1.4rem', fontWeight: 700, letterSpacing: '-0.02em', color: stat.cor }}>{stat.valor}</div>
            <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 2 }}>{stat.label}</div>
            <div style={{ height: 3, borderRadius: 2, background: 'var(--border)', marginTop: 10, overflow: 'hidden' }}>
              <div style={{ height: '100%', borderRadius: 2, width: `${stat.pct}%`, background: stat.cor }} />
            </div>
          </div>
        ))}
      </div>

      {/* Content */}
      {tab === 'pipeline' && <PipelineView clients={clients} onEdit={setEditCliente} />}
      {tab === 'clients' && <ClientsTable clients={clients} />}

      {/* Create Modal */}
      <ClientModal
  open={modalOpen}
  cliente={null}
  onClose={() => setModalOpen(false)}
  onSave={handleCreate}
/>
{/* Update Modal */}
     <ClientModal
  open={!!editCliente}
  cliente={editCliente}
  onClose={() => setEditCliente(null)}
  onSave={async (dados) => {
    const { updateClient } = await import('../../services/clientService');
    await updateClient(editCliente.id, dados);
  }}
  onDelete={async (id) => {
    const { deleteClient } = await import('../../services/clientService');
    await deleteClient(id);
  }}
/>
    </>
  );
}